// Dependecies
import React from 'react';
import PropTypes from 'prop-types';
import ListGroup from 'react-bootstrap/ListGroup';
import { useTranslation } from 'react-i18next';
import Moment from 'react-moment';
// Hook
import useGeneralInformation from '../../hooks/useGeneralInformation';

function ListGroupDashboardVehicle({ plate }) {
  const { dataInformation } = useGeneralInformation(plate);
  const { t } = useTranslation(['dahsboard']);

  return (
    <>
      <ListGroup variant="flush">
        <ListGroup.Item>
          {t('total_mileage')} <span className="right">{dataInformation.distance} km</span>
        </ListGroup.Item>
        {/*  TODO: Se deja comentado mientras obtenemos el dato de flespi
        <ListGroup.Item>
            {t('operational_hours')}
            <span className="right">{dataInformation.hours_operations} horas</span>
          </ListGroup.Item> 
        */}
        <ListGroup.Item>
          {t('last_maintenance')}
          <span className="right">
            <Moment format="DD/MM/YYYY">{dataInformation.last_mantenaice}</Moment>
          </span>
        </ListGroup.Item>
        <ListGroup.Item>
          {t('status')} <span className="right">{dataInformation.status}</span>
        </ListGroup.Item>
      </ListGroup>
    </>
  );
}
ListGroupDashboardVehicle.propTypes = {
  plate: PropTypes.string.isRequired,
};
export default ListGroupDashboardVehicle;
